import { render } from "./CreateSpaceForm.vue?vue&type=template&id=26c2c120"
import script from "./CreateSpaceForm.vue?vue&type=script&lang=js"
export * from "./CreateSpaceForm.vue?vue&type=script&lang=js"
script.render = render

export default script